import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";

const EmployeeDetailsPageContent = lazy(() => import("./EmployeeDetailsPageContent"));

function EmployeeDetailsPageInternal() {
    return (
        <DefaultPage>
            <EmployeeDetailsPageContent />
        </DefaultPage>
    );
}

export const EmployeeDetailsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(
    EmployeeDetailsPageInternal
);
